export class Dropdown {
  public id: string; // id of dropdown item
  public name: string; // name of dropdown item
  public disabled = false;
}
